import { render, staticRenderFns } from "./HowToWifiNew.vue?vue&type=template&id=7ab27f6c&"
import script from "./HowToWifiNew.vue?vue&type=script&lang=js&"
export * from "./HowToWifiNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports